export default "__VITE_ASSET__BMlP25r6__"